/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import { Field, Form, Formik } from "formik";
import { HelpPopup } from "../../components/helpPopup/helpPopup";
import * as Yup from "yup";
import { MessageText } from "../../constants/messageText";
import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { TextBox } from "../../components/allInputsFields/textBox/textBox";
import "./guestSignUp.scss";
import instance from "../../utils/axiosInstance";
import React, { useEffect } from "react";
import { ErrorCodes } from "../../constants/messageCodes";
import { SnackBarMessage } from "../../components/snackBar/snackBar";
import { SignUpSucees } from "../../components/signUpSucees/signUpSucees";
import { useNavigate } from "react-router-dom";
import { CreateGuestUser } from "../../constants/api-urlConstants";
import { isMobile } from 'react-device-detect';
import { publicDomainUrl } from "../../utils/config";

export const GuestSignUp: React.FC<any> = () => {
  const navigate = useNavigate();
  const [guestSignIsLoading, setGuestSignIsLoading] = React.useState(false);
  const [showInfromation, setShowInfromation] = React.useState<any>(false);
  const [APIMsgConfig, setAPIMsgConfig] = React.useState({
    type: "",
    message: "",
    snackFlag: false,
  });
  const initial_state = {
    firstName: "",
    lastName: "",
    email: "",
    privacy: false,
  };

  const onlyText = /^[A-Za-z0-9 ]+$/;
  const noFreeMailBoxes =
    /^[a-zA-Z0-9_.+-]+@(?!(gmail|yahoo|hotmail|aol)).*\.[a-zA-Z]{2,100}$/gm;

  const SigninFormValidation = Yup.object().shape({
    firstName: Yup.string()
      .min(2, MessageText.VALIDATION_MIN_2)
      .required(MessageText.VALIDATION_FIRSTNAME_REQUIRED)
      .trim(MessageText.VALIDATION_FIRSTNAME_REQUIRED)
      .matches(onlyText, MessageText.SPECIAL_CHARACTERS_ARE_NOT_ALLOWED),
    lastName: Yup.string()
      .min(1, MessageText.VALIDATION_MIN_2)
      .required(MessageText.VALIDATION_LASTNAME_REQUIRED)
      .matches(onlyText, MessageText.SPECIAL_CHARACTERS_ARE_NOT_ALLOWED)
      .trim(MessageText.VALIDATION_LASTNAME_REQUIRED),
    email: Yup.string()
      .email(MessageText.VALIDATION_EMAIL_FORMAT)
      .matches(noFreeMailBoxes, MessageText.VALIDATION_EMAIL_DOMAIN)
      .required(MessageText.VALIDATION_EMAIL_REQUIRED),
    privacy: Yup.boolean().oneOf(
      [true],
      "You need to accept the Privacy Policy and terms and conditions"
    ),
  });

  useEffect(() => {
    if (window.location.pathname?.includes('trial_signup')) {
      window.location.href = `${publicDomainUrl}/trial_signup?${window.location.search.slice(1)}`;
    }
  }, [])

  const createGuestUser = (userData: any) => {
    setGuestSignIsLoading(true);
    const userCreatedBy = window.location.search;
    const payload: any = {
      firstName: userData.firstName.trim(),
      lastName: userData.lastName.trim(),
      email: userData.email,
      key: userCreatedBy.slice(1),
      mobile: isMobile
    };
    const USER_API_BASE_URL = `${CreateGuestUser}`;
    instance
      .post(USER_API_BASE_URL, payload)
      .then((response) => {
        const res = response.data;
        setGuestSignIsLoading(false);
        if (res.success) {
          setGuestSignIsLoading(false);
          setShowInfromation(true);
        }
        else {
          if (res.message_code === ErrorCodes.DUPLICATE_USERNAME) {
            setAPIMsgConfig({
              type: 'error',
              message: MessageText.EMAIL_ALREADY_EXIST,
              snackFlag: true
            })
          } else if (res.message_code === ErrorCodes.INVALID_EMAIL) {
            setAPIMsgConfig({
              type: 'error',
              message: MessageText.EMAIL_FORMAT_INVALID,
              snackFlag: true
            })
          } else if (res.message_code === ErrorCodes.INVALID_GUEST_QR) {
            setAPIMsgConfig({
              type: 'error',
              message: MessageText.INVALID_GUEST_QR_Text,
              snackFlag: true
            })
          } else {
            setAPIMsgConfig({
              type: 'error',
              message: MessageText.WENT_WRONG,
              snackFlag: true
            })
          }
        }
      })
      .catch((error) => {
        setGuestSignIsLoading(false);
        setAPIMsgConfig({
          type: 'error',
          message: MessageText.WENT_WRONG,
          snackFlag: true
        })

      });
  };

  const okClick = () => {
    navigate("/login");
  };

  return (
    <>
      <div className="guest-signUp-wrapper flex-direction-column">
        <div className="pageHeader vertical-align">
          <img
            style={{ width: "220px", paddingLeft: "10px" }}
            alt=""
            src={require("../../assets/images/infraclearlogo.png")}
          />
          <HelpPopup />
        </div>
        <div className="authWrapper">
          <div className="login-wrapper ">
            {!showInfromation ? (
              <div className="login-popup">
                <div className="loginWrapper">
                  <span className="title">Sign in</span>
                  <Formik
                    initialValues={initial_state}
                    validationSchema={SigninFormValidation}
                    onSubmit={(value: any) => {
                      createGuestUser(value);
                    }}
                  >
                    {(formik) => (
                      <Form onSubmit={formik.handleSubmit}>
                        <Box sx={{ mt: 2 }}>
                          <TextBox
                            formikRef={formik}
                            textBoxName={"firstName"}
                            textBoxLabel={"First Name*"}
                            alphaNumaricInputText={true}
                            inputPropsObj={{
                              maxLength: 25,
                              spellCheck: false,
                            }}
                            margin={"dense"}
                            onChangeCallBack={(data: any) => {
                              formik.setFieldValue("firstName", data);
                            }}
                          />
                          <TextBox
                            formikRef={formik}
                            textBoxName={"lastName"}
                            textBoxLabel={"Last Name*"}
                            alphaNumaricInputText={true}
                            inputPropsObj={{
                              maxLength: 25,
                              spellCheck: false,
                            }}
                            margin={"dense"}
                            onChangeCallBack={(data: any) => {
                              formik.setFieldValue("lastName", data);
                            }}
                          />
                          <TextBox
                            formikRef={formik}
                            textBoxName={"email"}
                            inputPropsObj={{ spellCheck: false }}
                            textBoxLabel={"Email *"}
                            margin={"dense"}
                            onChangeCallBack={(data: any) => {
                              formik.setFieldValue("email", data);
                            }}
                          />
                          <div className="checkboxField">
                            <div className="checkBox">
                              <Field type="checkbox" name="privacy" />
                            </div>
                            <span className="termPolicyGuest">
                              By checking this box, I acknowledge that I have
                              read and agree to Infraclear’s{" "}
                              <a
                                href="https://infraclear.com/terms-of-use"
                                target="_blank"
                                rel="noreferrer"
                                className="subTitlePrivacy"
                              >
                                Terms of Use
                              </a>{" "}
                              and{" "}
                              <a
                                href="https://infraclear.com/privacy-policy"
                                target="_blank"
                                rel="noreferrer"
                                className="subTitlePrivacy"
                              >
                                Privacy Policy
                              </a>
                            </span>
                          </div>
                          <div className="loader">
                            <Button
                              type="submit"
                              fullWidth
                              variant="contained"
                              sx={{ mt: 2, mb: 2 }}
                              style={{ textTransform: "none" }}
                              className={
                                !(formik.isValid && formik.dirty)
                                  ? "signupBtnDisabled"
                                  : "signupBtn"
                              }
                              disabled={
                                !(formik.isValid && formik.dirty) ||
                                guestSignIsLoading
                              }
                            >
                              {!guestSignIsLoading ? (
                                "Sign in"
                              ) : (
                                <div className="submitFormLoading">
                                  <CircularProgress color="inherit" size={20} />
                                </div>
                              )}
                            </Button>
                          </div>
                        </Box>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            ) : (
              <>
                <SignUpSucees
                  closeConfirmation={okClick}
                  showText={MessageText.GUEST_SIGNUP_MSG_DESC}
                  showMobileText={MessageText.MOBILE_GUEST_SIGNUP_MSG_DESC}
                  popupName={"guestUserSignUp"}
                  popupDevice={isMobile}
                />
              </>
            )}
          </div>
        </div>
      </div>
      {APIMsgConfig.snackFlag && (
        <div>
          <SnackBarMessage snacBarValue={APIMsgConfig} />
        </div>
      )}
    </>
  );
};
